import {BaseConverter} from '../../base/converters/base-converter.converter';
import {BasicProductModel} from '../models/basic-product.model';
import {BasicProduct} from '../../shared/DTO/basicProduct';
import {IdentityConverter} from './identity.converter';
import {ProductTypeConverter} from './product-type.converter';
import {Injectable} from '@angular/core';
import {BasicProperty1Converter} from "./properties.converter";

@Injectable()
export class BasicProductConverter extends BaseConverter<BasicProductModel, BasicProduct> {

  constructor(private identityConverter: IdentityConverter, private productTypeConverter: ProductTypeConverter, private basicProperty1Converter: BasicProperty1Converter) {
    super();
  }

  convertToDto(model: BasicProductModel): BasicProduct {
    if (!model) {
      return;
    }
    return {
      activationDate: model.activationDate ? model.activationDate.valueOf(): null,
      certifiedEmail: model.certifiedEmail,
      description: model.description,
      duration: model.duration,
      expirationDate: model.expirationDate,
      identity: this.identityConverter.convertToDto(model.identity),
      productType: this.productTypeConverter.convertToDto(model.productType),
      state: model.state,
      unitId: model.unitId,
      userId: model.userId,
      properties: this.basicProperty1Converter.convertToDtoList(model.properties)
    };
  }

  convertToModel(dto: BasicProduct): BasicProductModel {
    if (!dto) {
      return null;
    }
    let model: BasicProductModel = new BasicProductModel();

    model.activationDate = dto.activationDate;
    model.certifiedEmail = dto.certifiedEmail;
    model.description = dto.description;
    model.duration = dto.duration;
    model.expirationDate = dto.expirationDate;
    model.identity = this.identityConverter.convertToModel(dto.identity);
    model.productType = this.productTypeConverter.convertToModel(dto.productType);
    model.state = dto.state;
    model.unitId = dto.unitId;
    model.userId = dto.userId;
    model.properties = this.basicProperty1Converter.convertToModelList(dto.properties);
    return model;
  }

}
